import { SxProps } from '@mui/material';

export const headerMiniCartContainerSX: SxProps = {
	p: '15px 20px',
	gap: '10px',
};

export const headerMiniCartImageSX: SxProps = {
	width: '90px',
	height: '90px',
};
